import { CheckName } from 'dashboard/models/check/check';
import { VerificationCheckConfig } from 'dashboard/models/verification-check-config/verification-check-config';

export type SelfieLivenessCheckName = CheckName.SelfieLivenessDetection;

export interface SelfieLivenessCheckConfig extends VerificationCheckConfig {
  check: SelfieLivenessCheckName;
  'minimal-risk-threshold': number;
  'low-risk-threshold': number;
  'medium-risk-threshold': number;
  'liveness-threshold': number;
  'normalized-liveness-threshold': number;
}

export function isSelfieLivenessCheck(
  verificationCheck: VerificationCheckConfig,
): verificationCheck is SelfieLivenessCheckConfig {
  switch (verificationCheck.check) {
    case CheckName.SelfieLivenessDetection:
      return true;
    default:
      return false;
  }
}
